import { ThemeProvider } from '@material-ui/core';
import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { createTheme } from "../utils/createTheme";
var THEME_DEFAULT = createTheme();
var THEME_TEST = createTheme({
  overrides: {
    MuiButton: {
      sizeLarge: {
        borderRadius: '32px',
        padding: '20px'
      },
      sizeSmall: {
        borderRadius: '17px',
        padding: '10px'
      }
    }
  }
});
export function ABThemeProvider(props) {
  var theme = props.theme === 'test' ? THEME_TEST : THEME_DEFAULT;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(StyledComponentsThemeProvider, {
    theme: theme
  }, props.children));
}